export default {
  common: {
    confirm: 'Confirm',
    confirmed: 'Confirmed',
    cancel: 'Cancel',
    select: 'Please Select',
    search: 'Search',
    notice: 'Notice',
    confirmRole: 'Confirm Role',
    announce: 'Announcement'
  },
  pay: {
    title: {
      SelectCharacter: 'Select Character',
      SelectBundle: 'Select Bundle',
      game: 'Game',
      gamePlaceholder: 'Select Game',
      server: 'Server',
      serverPlaceHolder: 'Select Server',
      role: 'Role',
      rolePlaceHolder: 'Select Role'
    },
    instructions: {
      title: 'Recharge Instructions',
      subtext: 'Service Instructions',
      paragraph1:
        '1. To safeguard your rights and interests, please carefully read the detailed product description before making a purchase.',
      paragraph2:
        '2. This service is only available to users who have already created a character within the game. Users who have not completed character creation will not be able to detect the corresponding server or character information on this page. Please confirm your character creation information before proceeding with the recharge.',
      paragraph3:
        '3. Important Note: After entering the server and character ID, please carefully verify your account character information. Only proceed to the next step after confirming that everything is correct!',
      paragraph4:
        '4. After a successful payment, the items purchased through this page will be delivered to your game account via in-game mail. If you have not received the items within 30 minutes after a successful recharge, you can contact the corresponding customer service through the in-game floating window to provide feedback. We will promptly resolve the issue for you.',
      paragraph5:
        '5. The time it takes for the recharge to be credited may vary due to network transmission delays. The final status of the recharge should be based on the actual display within the game. If you have any questions, please feel free to contact our customer service staff for assistance at any time.'
    },
    Region: 'Region',
    Server: 'Server',
    ServerPlaceholder: 'Server (Tap to Enter)',
    CharacterID: 'Character ID',
    CharacterName: 'Character Name',
    RoleName: 'Role Name',
    bundelDetails: 'Bundle Details',
    protocal: {
      services: 'Terms of services',
      policy: 'Privacy Policy',
      address: '5, 8/F,Mega Cube, 8 Wang Kwong Road, Kowloon Bay, Kowloon,Hong Kong',
      ysAddress: 'ward 7, North Jhagrakhand , maharana pratap ward, manendragarh, koriya, chhattisgarh Manendragarh - 497446',
    },
    dialogMessage: {
      reenter: 'Re-enter the character information?',
      selectServer: 'Please select a server',
      selectRoleId: 'Please enter the role ID',
      fillCharacterID: 'Please fill in your character id',
      confirmCharacter: 'Please confirm your character information first!'
    },
    footer: {
      safe: {
        title: 'Safe',
        subTitle: 'Official Top-up center'
      },
      convenient: {
        title: 'Convenient',
        subTitle: 'Pay with no obstacles'
      },
      economical: {
        title: 'Economical',
        subTitle: 'Rich rebate'
      },
      efficient: {
        title: 'Efficient',
        subTitle: 'Deliver with no delay'
      }
    },
    announce: {
      type: 'Activity'
    }
  },
  paySubmit: {
    paymenMethod: 'Payment Method',
    prodDetails: 'Delivery Details',
    discount: 'Discount',
    discountCode: 'Discount Code',
    submit: 'Submit',
    total: 'Order Total',
    fillDiscountCode: 'Please fill in your discount code',
    protocal: 'regulations have been read, have been confirmed',
    agree: 'Please agree protocal',
    currentRegion: 'Current Region',
    paymentMethods: 'Payment Methods',
    items: 'Items',
  }
};
